import React from 'react';

import { Alert } from '@lightspeed/flame/Alert';
import { theme } from '@lightspeed/flame/Core/themes/flame';
import { IconNotification } from '@lightspeed/flame/Icon/Notification';
import { Text, TextLink } from '@lightspeed/flame/Text';

import { getStorageNotificationTabKey } from 'root/apps/components/Notifications/utils';

export const NuOrderAlert = ({ tabKey }: { tabKey: string }) => {
  function handleOnClose() {
    const notificationKey = getStorageNotificationTabKey(tabKey);
    window.localStorage.setItem(notificationKey, JSON.stringify(0));
    window.dispatchEvent(new CustomEvent('notification_tab', { detail: { tabKey } }));
  }

  return (
    <Alert icon={<IconNotification />} margin={3} onClose={handleOnClose}>
      <Text fontWeight={theme.fontWeights.bold} fontSize={theme.fontSizes.text}>
        Save time by <TextLink href="/wholesale">linking your NuORDER account</TextLink>
      </Text>
      <Text color={theme.colors.textDimmed} fontSize={theme.fontSizes['text-s']}>
        Instantly sync your pre-orders, reorders or in-season orders and cut down on manual data
        entry tasks. <TextLink href="/wholesale">Learn more</TextLink>
      </Text>
    </Alert>
  );
};
